<template>
  <div class="global__alert">
    <b-modal size="lg" hide-footer id="createGlobalAlert" title="Create alert" class="modal-create-global-alert">
        <CreateGlobalAlert ref="refCreateGlobalAlert"/>
    </b-modal>
    <b-modal v-model="confirmDeleteAlert" type="warn" title="Confirm Deletion" @ok="deleteAlert(deleteAlertId)" ok-title="Yes, Delete">
        <p>Are you sure you want to delete this alert?</p>
    </b-modal>
    <b-modal size="lg" hide-footer id="globalAlertDetail1" class="modal-global-alert-detail">
        <template slot='modal-title'>
            {{alertTitle}}
            <p class="notification-sender">
            sent by {{ alertSender }} @ {{ getLocalAlertTime(alertTime) }}
            </p>
        </template>
        <span v-html="alertDetail"></span>
    </b-modal>
    <b-modal size="lg" hide-footer id="alertStatusDetail" title="Alert Status Log" class="modal-alert-status-detail">
        <table class="table table-striped table-bordered table-hover">
            <thead>
                <tr>
                    <th>User</th>
                    <th>Status</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(alertStatus, index) in alertStatusDetail" :key="index">
                    <td>{{ alertStatus.name }}</td>
                    <td>
                        <span v-if="alertStatus.status == 1" class="badge badge-primary">Read</span>
                        <span v-if="alertStatus.status == 0" class="badge badge-danger">Unread</span>
                    </td>
                </tr>
            </tbody>
        </table>
    </b-modal>
    <HeaderControls @createNewAlert="createAlert" />
    <div class="fixed-top-bar-padding">
        <div class="container-fluid">
            <div class="deliverable-header">
                <h2>
                    <div @click="createAlert" class="media-call-icon">
                        <img width="30px" src="@/csmworkflow/img/bell-module.svg"/>
                        <span class="add-media-call-icon">
                            <img src="@/csmworkflow/img/add-icon.svg"/>
                        </span>
                    </div>
                    Global Alert
                </h2>
            </div>
        </div>

        <div class="container-fluid">
            <div class="global-alerts-status">
                <span v-if="typeof allAlerts.data != 'undefined' && allAlerts.data.length == 0"><h2>There are no alerts at the moment.</h2></span>
                <div class="alert-item clearfix">
                    <ul v-if="typeof allAlerts.data != 'undefined' && allAlerts.data.length > 0" class="list-unstyled">
                        <li
                        :key="'alert-'+index"
                        v-for="(alert,index) in allAlerts.data"
                        @click="seltAlert(alert)"
                        class="cursor-pointer"
                        >
                            <div>
                                <span class="info-bubbles">
                                <span class="initials badge badge-primary cursor-pointer">
                                    {{ alert.sender | textInitials }}
                                </span>
                                </span>
                                <span @click.stop="confirmDeleteAlert=true; deleteAlertId = alert.id;" class="remove-alert cursor-pointer">
                                    <i class="fas fa-trash"></i>
                                </span>
                                <span @click.stop="showStatusDetail(alert)" class="alert-detail cursor-pointer">
                                    <i class="fas fa-info"></i>
                                </span>
                                <p class="details">
                                    <span class="alert__name cursor-pointer fw-bold">{{ alert.title }}</span>
                                    <br>
                                    <span class="notification-sender">
                                        <span class="fw-bold">{{ alert.sender }} @ {{ getLocalAlertTime(alert.created_at) }}</span>
                                    </span>
                                    <br>
                                    <span v-if="alert.message.length > 120">
                                        {{alert.message.substring(0, 120)+'...' | striphtml}}
                                    </span>
                                    <span v-else>
                                        {{alert.message | striphtml}}
                                    </span>
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
                <!-- <table class="table table-striped table-bordered table-hover" v-if="typeof allAlerts.data != 'undefined' && allAlerts.data.length > 0">
                    <thead>
                        <tr>
                            <th>Title</th>
                            <th>Message</th>
                            <th>Sent</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr :key="'alert-'+index" v-for="(alert,index) in allAlerts.data" @click="seltAlert(alert)" class="cursor-pointer">
                            <td class="position-relative">
                                <span>
                                    {{ alert.title }}
                                </span>
                                <span v-b-tooltip.hover title="Delete alert" class="cursor-pointer delete-alert" @click.stop="deleteAlert(alert.id)">
                                    <img src="@/csmworkflow/img/popup-minus.png"/>
                                </span>
                            </td>
                            <td>
                                <span class="truncate-text">
                                    {{ alert.message }}
                                </span>
                            </td>
                            <td>
                                {{ alert.created_at | moment('MMM DD @ HH:mm') }}
                            </td>
                            <td>
                                <a href="#" @click.stop="showStatusDetail(alert)">
                                    Detail
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table> -->
                <div class="pagination-wrapper">
                    <pagination :data="allAlerts" @pagination-change-page="onChangePage" :limit="5"></pagination>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import toast from "../toast";
import HeaderControls from "../components/common/HeaderControls";
import CreateGlobalAlert from "../components/common/CreateGlobalAlert";
import { mapActions, mapGetters } from 'vuex';

export default {
    data() {
        return {
            alertTitle: '',
            alertDetail: '',
            alertTime: '',
            alertSender: '',
            confirmDeleteAlert: false,
            deleteAlertId: '',
            alertStatusDetail: []
        }
    },
    components: {
        HeaderControls,
        CreateGlobalAlert
    },
    computed: {
        ...mapGetters(['allAlerts']),
    },
    mounted() {
        this.fetchAlerts();
    },
    methods: {
        ...mapActions(['fetchAlerts']),
        onChangePage(data) {
            this.fetchAlerts(data);
        },
        createAlert() {
            this.$bvModal.show('createGlobalAlert');
        },
        deleteAlert(alertId) {
            this.$store.dispatch('deleteAlert', { alertId });
        },
        seltAlert(alert) {
            this.alertTitle = alert.title;
            this.alertDetail = alert.message;
            this.alertSender = alert.sender;
            this.alertTime = alert.created_at;
            this.$bvModal.show('globalAlertDetail1');
        },
        showStatusDetail(alert) {
            this.alertStatusDetail = this.allAlerts.statusesDetail[alert.id];
            this.$bvModal.show('alertStatusDetail');
        },

        getLocalAlertTime(time) {
            const alertTime = this.$moment.utc(time);
            alertTime.local();
            return alertTime.format('MMM Do, hh:mm a');
        }
    }
}
</script>

<style>

</style>
